module.exports = __webpack_public_path__ + "static/media/logo.774fdd51.png";